import { AxiosError } from "axios";
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

type ErrorResponse = { message?: string };

const hasMessage = (data: unknown): data is ErrorResponse => {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  const maybeMessage = (data as Record<string, unknown>).message;
  return typeof maybeMessage === "string";
};

export function getErrorMessage(error: AxiosError): string {
  const responseData = error.response?.data;

  if (hasMessage(responseData)) {
    return responseData.message ?? "Erro desconhecido ao carregar dados";
  }

  if (error.message) {
    return error.message;
  }
  console.error(responseData);
  return 'Erro desconhecido ao carregar dados';
};
